export default "__VITE_ASSET__CQN8CcuD__"